import * as yup from '~/utils/yup';

const CardConfigItemSchema = yup.object({
  required: yup.boolean().required(),
  show: yup.boolean().required(),
  name: yup.string().required(),
  type: yup
    .string()
    .oneOf(['text field', 'attribute_input', 'attribute_textarea'])
    .required(),
});

export const ActionCardConfig = yup
  .object({
    param1: CardConfigItemSchema,
    param2: CardConfigItemSchema,
    param3: CardConfigItemSchema,
    param4: CardConfigItemSchema,
    customerAttribute: yup.object({
      required: yup.boolean().required(),
    }),
  })
  .transform((value, originalValue) => {
    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch {
        return originalValue;
      }
    }

    return value;
  });

export type ActionCardConfig = yup.InferType<typeof ActionCardConfig>;
